
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import store from '@/store/store.js'
import { axiosConfig } from '@/axios.js'
var socket;
var stompClient;
export default {
  connect() {

    socket = new SockJS(axiosConfig.baseURL + '/gs-guide-websocket')
    // socket=new SockJS('http://192.168.1.3:443/gs-guide-websocket')
    stompClient = Stomp.over(socket);

    stompClient.connect(
      {},
      () => {

        store.dispatch('isSocketConnected', true)


        stompClient.subscribe("/topic/notifications." + store.state.AppActiveUser.customer_No, () => {


          // this.$store.state.received_messages.push(JSON.parse(tick.body).content);
          store.state.received_messages.push({
            index: 1,
            title: 'Commande',
            msg: 'nouvelle commande est en route',
            icon: 'MapIcon',
            // time     : this.randomDate({sec: 10}),
            category: 'primary'
          });
        });
        /*gggg*/
        stompClient.subscribe("/topic/notifications", () => {


          store.state.received_messages.push({
            index: 1,
            title: 'Produit',
            msg: 'Une nouvelle article a été ajouté',
            icon: 'MapIcon',
            // time     : this.randomDate({sec: 10}),
            category: 'success'
          });
        });

      },
      () => {

        store.dispatch('isSocketConnected', false)
      }
    );
  },
  disconnect() {
    if (stompClient) {

      stompClient.disconnect();
    }
    store.dispatch('isSocketConnected', false)
  },
}